import { render } from "./Swiper.vue?vue&type=template&id=507a278e&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=507a278e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-507a278e"

export default script